/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiExternalUserFromJSON(json) {
    return StreemApiExternalUserFromJSONTyped(json, false);
}
export function StreemApiExternalUserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userSid': !exists(json, 'user_sid') ? undefined : json['user_sid'],
        'externalUserId': !exists(json, 'external_user_id') ? undefined : json['external_user_id'],
    };
}
export function StreemApiExternalUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user_sid': value.userSid,
        'external_user_id': value.externalUserId,
    };
}
//# sourceMappingURL=StreemApiExternalUser.js.map